import { Component, OnInit, inject } from '@angular/core';
import { BrowserInfo } from './browser-support.model';
import { BrowserSupportDetectionService } from './browser-support-detection.service';
import { UiModule } from '../ui/ui.module';

@Component({
  selector: 'ifc-browser-warning',
  standalone: true,
  imports: [UiModule],
  templateUrl: './browser-warning.component.html',
  styleUrls: ['./browser-warning.component.scss'],
})
export class BrowserWarningComponent implements OnInit {
  private readonly browserService = inject(BrowserSupportDetectionService);
  
  showWarning = false;
  browserInfo: BrowserInfo = null;
  recommendedBrowsers = '';

  private readonly DISMISSED_KEY = 'browser-warning-dismissed';

  ngOnInit(): void {
    if (sessionStorage.getItem(this.DISMISSED_KEY)) {
      return;
    }

    this.browserInfo = this.browserService.detectBrowser();

    if (this.browserInfo && !this.browserInfo.isRecommended) {
      this.showWarning = true;
      this.recommendedBrowsers = this.browserService.getRecommendedBrowsersList();
    }
  }

  dismiss(): void {
    sessionStorage.setItem(this.DISMISSED_KEY, 'true');
    this.showWarning = false;
  }
}
